// import { map } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
// import axios from 'axios';
// ---------------------- SET UP NEW AXIOS ------------------------------------------------

import { apiConfig } from '../../config';
import { isValidToken, refreshAuthToken, setSession } from './authJwt';

const axiosInstance = axios.create({
  baseURL: apiConfig.endpointPdf,
  headers: {
    // 'Access-Control-Allow-Origin': '*',
    Accept: 'application/pdf'
  }
});

axiosInstance.interceptors.request.use(
  async (request) => {
    if (request.headers.Authorization) {
      if (!isValidToken(request.headers.Authorization)) {
        // If not refresh token query
        if (!(request.data.query.indexOf('refreshToken') > -1)) {
          const response = await refreshAuthToken();
          await setSession(response.data.data.refreshToken.AccessToken);
          request.headers.Authorization = `Bearer ${response.data.data.refreshToken.AccessToken}`;
          // window.location.reload();
        }
      }
    }
    return request;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Response interceptor for API calls
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.debug(error);
    return Promise.reject(error);
  }
);

// ----------------------------------------------------------------------

// const parseParams = (params) => {
//   const paramsStringify = JSON.stringify(params);
//   return paramsStringify.replace(/"([^"]+)":/g, '$1:').slice(1, -1);
// };

const initialState = {
  isLoading: false,
  error: false,
  pdfErrors: {},
  pdfBase64: ''
};

const slice = createSlice({
  name: 'pdf',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      console.debug('hasError: ', action.payload);
    },

    // RESET TO INITIAL STATE
    clearPdfDataSuccess(state) {
      state.pdfBase64 = initialState.pdfBase64;
    },

    // GET PDF AS BASE64 STRING
    getPdfBase64Success(state, action) {
      console.debug('getPdfBase64 - success');
      state.pdfBase64 = action.payload.data;
      state.isLoading = false;
      /* remove getPdf error */
      delete state.pdfErrors.getPdfUrl;
      state.error = false;
    },
    getPdfBase64Failure(state, action) {
      console.debug('getPdfBase64 - fail');
      state.isLoading = false;
      state.error = true;
      state.pdfErrors.getPdfBase64 = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function clearPdfData() {
  // console.debug('clearPdfData()');
  return async (dispatch) => {
    dispatch(slice.actions.clearPdfDataSuccess());
  };
}

/** Generate PDF Directly */
// export function getPdfBase64(eventInput) {
//   console.debug('getPdfBase64()');
//   return async (dispatch) => {
//     dispatch(slice.actions.startLoading());

//     try {
//       const response = await axiosInstance.post(
//         '/generate-pdf-base64',
//         eventInput
//       );
//       console.debug('getPdfBase64: response = ', response);

//       dispatch(slice.actions.getPdfBase64Success(response));
//     } catch (error) {
//       dispatch(slice.actions.getPdfBase64Failure('Failed to generate pdf'));
//       dispatch(slice.actions.clearPdfDataSuccess());
//     }
//   };
// }

/** Generate PDF through GraphQL endpoint */
export function getPdfBase64(eventInput) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    const input = JSON.stringify(eventInput).replace(/"([^"]+)":/g, '$1:');
    const queryString = `
      mutation {
        generatePdfBase64(input: ${input}) {
          data
        }
      }
    `;

    try {
      const response = await axios.post('/graphql', {
        query: queryString
      });

      const result = response.data.data.generatePdfBase64;
      dispatch(slice.actions.getPdfBase64Success(result));
    } catch (error) {
      dispatch(slice.actions.getPdfBase64Failure('Failed to generate PDF'));
      dispatch(slice.actions.clearPdfDataSuccess());
    }
  };
}
